// extracted by mini-css-extract-plugin
export default {"container":"GroupIcon-module__container--hHAEI","animatedBackground":"GroupIcon-module__animatedBackground--o2P1_"};